export default "__VITE_ASSET__C3iwVlk5__"